import React from 'react';
import '../App.css';
import founder from './images/founder.png';

export default function Founder() {
  return (
    <>
    <div className=" w-100 py-5" style={{ background: 'linear-gradient(to right ,#08274d,#031428)', overflowX: 'hidden' }}>
      <div className='container'>
      <div className="container-fluid px-3">
        <div className=" row justify-content-center align-items-center g-5 overflow-hidden">
         
          <div className=" col-11 col-sm-10 col-md-4 text-center bg-white rounded-3 p-3 custom-shadow ">
            <img src={founder} alt="Founder" className="img-fluid mb-3" style={{ maxWidth: '200px' }} />
            <h5 style={{ color: '#5F648E' }}>Mrs. DIVYA L</h5>
            <p className="text-secondary" style={{ fontSize: '12px' }}>
              Co-founder MDQuality Apps and Solutions
            </p>
            <p style={{ color: '#CC6300', fontSize: '12px' }}>
              "We didn’t just build software — we built a solution that thinks like a manufacturer and grows like a partner."
            </p>
          </div>

          <div className="col-12 col-md-8 text-light">
            <h1 className="gradient-heading mb-4">Founder’s Note</h1>
            <p className="mb-4">At MDQ, we’ve always believed that the right technology can empower businesses to operate smarter, faster, and better. The Production Management System (PMS) was born out of that belief — built not just to manage processes, but to transform them.</p>
            <p className="mb-4">Our journey began with a simple goal: to bridge the gap between day-to-day production realities and intelligent, data-driven decisions. We listened closely to manufacturers, understood their pain points, and crafted a system that adapts to their unique needs</p>
            <p className="mb-4">Today, PMS is more than a software — it’s a trusted partner for teams looking to scale without complexity.</p>
            <p className="mb-0">We remain committed to constant innovation, user-friendly design, and unwavering support — because your growth is our mission</p>
          </div>

        </div>
      </div>
      </div>
    </div>
    </>
  );
}
